//
//  src/layouts/mobile/home/Home.js
//
import * as React from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import Nav      from "../../../components/nav/Nav"
import Landing  from "../../../components/landing/Landing"
import Footer   from "../../../components/footer/Footer"
import './Home.css'


//
//  hom
//
export default function Home() {
    const location = useLocation();
    const canonicalUrl = `https://jefftattooer.com${location.pathname}`.replace(/\/$/, '') || 'https://jefftattooer.com';
    const ogImage = 'https://jefftattooer.com/logo512.png';
    
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "Jeff Tattooer",
        "image": ogImage,
        "@id": "https://jefftattooer.com",
        "url": "https://jefftattooer.com",
        "email": "jeff@jefftattooer.com",
        "address": {
            "@type": "PostalAddress",
            "streetAddress": "The Melbourne Compendium",
            "addressLocality": "Melbourne",
            "addressRegion": "VIC",
            "addressCountry": "AU"
        },
        "geo": {
            "@type": "GeoCoordinates",
            "latitude": -37.8550852,
            "longitude": 145.0183096
        },
        "priceRange": "$$"
    };
    
    const personStructuredData = {
        "@context": "https://schema.org",
        "@type": "Person",
        "name": "Jeff Tattooer",
        "jobTitle": "Tattoo Artist",
        "url": "https://jefftattooer.com",
        "email": "jeff@jefftattooer.com",
        "sameAs": [
            "https://www.facebook.com/JeffTattooer/",
            "https://www.instagram.com/jeff_tattooer/"
        ]
    };
    
    return (
        <div id="home">
            <Helmet>
                <title>Jeff Tattooer | Professional Realistic Tattoo Artist in Melbourne</title>
                <meta name="description" content="Professional Melbourne tattoo artist specializing in realistic tattoos, blackwork, traditional, and neo-traditional styles. Book your consultation today." />
                <link rel="canonical" href={canonicalUrl} />
                
                {/* Open Graph */}
                <meta property="og:title" content="Jeff Tattooer | Professional Realistic Tattoo Artist in Melbourne" />
                <meta property="og:description" content="Professional Melbourne tattoo artist specializing in realistic tattoos, blackwork, traditional, and neo-traditional styles. Book your consultation today." />
                <meta property="og:image" content={ogImage} />
                <meta property="og:url" content={canonicalUrl} />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Jeff Tattooer" />
                
                {/* Twitter Card */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Jeff Tattooer | Professional Realistic Tattoo Artist in Melbourne" />
                <meta name="twitter:description" content="Professional Melbourne tattoo artist specializing in realistic tattoos, blackwork, traditional, and neo-traditional styles. Book your consultation today." />
                <meta name="twitter:image" content={ogImage} />
            </Helmet>
            <Helmet>
                <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
                <script type="application/ld+json">{JSON.stringify(personStructuredData)}</script>
            </Helmet>
           <Nav      />
           <Landing  />
           <Footer   />
        </div>
    );
}
